import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "utils/api";
import { getSessionData } from "utils/common";
import { showMessage } from "../common.slice";
const initialState = {
  adminSubBrokerUserList: [],
  adminSubBrokerUserLoading: false,
  isAdminSubBrokerUsersUpdated: false,
  adminSubBrokerUsersTotalRecords: 0,
  adminSubBrokerUsersSearchText: "",
  activeUser: 0,
  sortAdminSubBrokerUserArr: [],

  adminSystemUserList: [],
  totalAdminSystemUserList: 0,
  adminSystemUserLoading: false,
  isUpdatedAdminSystemUser: false,
  adminSortSystemUserArr: [],
  subBrokerUsersViewData: [],
  multiDeleteSystemUserList: [],
  searchTextSystemUserMap: "",

  adminClientMapList: [],
  adminClientMapLoading: false,
  searchTextClientMap: "",
  adminSortClientMapArr: [],

  userRightsList: [],
  isUserRightsList: false,
  userAuthorityLimits: [],
  userAuthorityLimitstLoading: false,
  isUserAuthorityLimitsUpdate: false,

  userAuthorityList: [],
  userAuthorityListLoading: false,

  callPutSettingFromMasterAcc: {}
};

const adminSubBrokerData = [];

export const getAdminSubBrokerUser = createAsyncThunk(
  "admin/sub broker user",
  () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(adminSubBrokerData);
      }, 1000);
    });
  }
);

export const getAuthoritysList = createAsyncThunk(
  "admin/getUserauthorityList",
  (id) => {
    return new Promise((resolve, reject) => {
      let { userId } = getSessionData();
      api
        .get(`common/get-authority-by-userid/${userId}`)
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            resolve(data);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const getAuthoritysLimits = createAsyncThunk(
  `settings/getAuthorityLimits`,
  (data) => {
    return new Promise((resolve, reject) => {
      const { pageNo, pageSize, searchText } = data;
      let { userId } = getSessionData();
      api
        .get(
          `settings/authorityLimits/get-authority-limits/${userId}/${pageNo}/${pageSize}${searchText ? `?searchText=${searchText}` : ""
          }`
        )
        .then((resData) => {
          if (resData.status === 200) {
            resolve(resData.data);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const addAuthoritysLimits = createAsyncThunk(
  `settings/addAuthoritysLimits`,
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { userId } = getSessionData();
      const saveLimitsObj = {
        createdBy: userId,
        id: data?.id ? data.id : 0,
        userId: data?.authority?.value ? parseInt(data?.authority?.value) : 0,
        noofSupperMasters: data?.superMaster ? data.superMaster : 0,
        noofMasters: data?.master ? data.master : 0,
        noofUsers: data?.user ? data.user : 0,
        noofSystemUsers: data?.systemUser ? data.systemUser : 0,
      };
      api
        .post("settings/authorityLimits/save-authority-limits", saveLimitsObj)
        .then((resData) => {
          if (resData.status === 200) {
            dispatch(
              showMessage({
                message: resData.data.message,
                varient: "success",
              })
            );
            const { data } = resData.data;
            resolve(data);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const deleteAuthoritysLimits = createAsyncThunk(
  `settings/deleteAuthoritysLimits`,
  (id, { dispatch }) => {
    return new Promise((resolve, reject) => {
      api
        .delete(`settings/authorityLimits/delete-authority-limits/${id}`)
        .then((resData) => {
          if (resData.status === 200) {
            const { data } = resData.data;
            resolve(data);
            dispatch(
              showMessage({
                message: resData.data.message,
                varient: "success",
              })
            );
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getUserRightsList = createAsyncThunk(
  "admin/getUserRightsList/list",
  (props) => {
    return new Promise((resolve, reject) => {
      const { userId, isMaster } = props
      api
        .get(`settings/authorityRights/get-authorityRights-by-userid/${userId}`)
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            resolve({ data: data, isMaster: isMaster });
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const saveUserRights = createAsyncThunk(
  "admin/saveUserRights",
  ({ values, userRightsList }, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let finalObject = {};
      let { userId } = getSessionData();
      finalObject.createdBy = userId;
      finalObject.userId = values.user.value;
      finalObject.formMasterPermission = userRightsList;
      api
        .post(`settings/authorityRights/add-authorityRights`, finalObject)
        .then((dataResponse) => {
          if (dataResponse.status == 200) {
            dispatch(
              showMessage({
                message: dataResponse.data.message,
                varient: "success",
              })
            );
            resolve(dataResponse);
          } else {
            dispatch(
              showMessage({
                message: dataResponse.data.message,
              })
            );
            reject(dataResponse);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(
              showMessage({
                message: error.response.data.message,
              })
            );
          } else if (error.request) {
            dispatch(
              showMessage({
                message: error.request.message,
              })
            );
          } else {
            dispatch(
              showMessage({
                message: error.message,
              })
            );
          }
          reject(error);
        });
    });
  }
);

export const getAdminSystemUsers = createAsyncThunk(
  "admin/system users",
  (data) => {
    return new Promise((resolve, reject) => {
      let { searchText, pageNo, pageSize, systemUserId } = data;
      api
        .get(
          `systemuser/get-system-user-map/${systemUserId}/${pageNo}/${pageSize}${searchText ? `?searchText=${searchText}` : " "
          }`
        )
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            resolve(data);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const saveAdminSystemUsers = createAsyncThunk(
  "admin/add-system-users-map",
  (data) => {
    return new Promise((resolve, reject) => {
      let { userId } = getSessionData();
      const objSystemUserMap = {
        id: data?.id ? data.id : 0,
        createdBy: userId,
        userId: data?.client?.value ? Number(data.client.value) : 0,
        systemUserId: Number(data?.systemUser?.value),
      };
      api
        .post("systemuser/save-system-user-map", objSystemUserMap)
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            resolve(data);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);
export const deleteSystemUsersMap = createAsyncThunk(
  `settings/delete-system-users-map`,
  (deleteSystemUserMap, { dispatch }) => {
    return new Promise((resolve, reject) => {
      api
        .post("systemuser/delete-system-users-map", deleteSystemUserMap)
        .then((resData) => {
          if (resData.status === 200) {
            const { data } = resData.data;
            resolve(data);
            dispatch(
              showMessage({
                message: resData.data.message,
                varient: "success",
              })
            );
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const getAdminClientMapList = createAsyncThunk(
  "admin/client map",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let { searchText, pageNo, pageSize, Id } = data;
      api
        .get(
          `settings/client-map/get-authority-user-by-id/${Id}/${pageNo}/${pageSize}${searchText ? `?searchText=${searchText}` : " "
          }`
        )
        .then((resData) => {
          if (resData.status === 200) {
            let { data } = resData.data;
            resolve(data);
          } else {
            reject(resData);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
);

export const saveClientMapList = createAsyncThunk(
  "admin/saveClientMapList",
  (values, { dispatch }) => {
    return new Promise((resolve, reject) => {
      let finalObject = {};
      let { userId } = getSessionData();
      finalObject.createdBy = userId;
      finalObject.userId = values.client.value;
      finalObject.authorityId = values.user.value;
      api
        .post(`settings/client-map/save-client-map`, finalObject)
        .then((dataResponse) => {
          if (dataResponse.status == 200) {
            dispatch(
              showMessage({
                message: dataResponse.data.message,
                varient: "success",
              })
            );
            resolve(dataResponse);
          } else {
            dispatch(
              showMessage({
                message: dataResponse.data.message,
              })
            );
            reject(dataResponse);
          }
        })
        .catch((error) => {
          if (error.response) {
            dispatch(
              showMessage({
                message: error.response.data.message,
              })
            );
          } else if (error.request) {
            dispatch(
              showMessage({
                message: error.request.message,
              })
            );
          } else {
            dispatch(
              showMessage({
                message: error.message,
              })
            );
          }
          reject(error);
        });
    });
  }
);

export const adminSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setSortAdminSubBrokerUser: (state, action) => {
      state.sortAdminSubBrokerUserArr = action.payload;
    },
    setActiveUser: (state, action) => {
      state.activeUser = action.payload;
    },
    setSubBrokerUsersViewData: (state, action) => {
      state.subBrokerUsersViewData = action.payload;
    },
    setSortAdminClientMap: (state, action) => {
      state.setSortAdminClientMap = action.payload;
    },
    setCallPutSettingFromMasterAcc: (state, action) => {
      state.callPutSettingFromMasterAcc = action.payload;
    },
    setIsUserAuthorityLimitsUpdate: (state, action) => {
      state.isUserAuthorityLimitsUpdate = action.payload;
    },
    setIsUpdatedAdminSystemUser: (state, action) => {
      state.isUpdatedAdminSystemUser = action.payload;
    },
    setMultiDeleteSystemUserList: (state, action) => {
      state.multiDeleteSystemUserList = action.payload;
    },
    setSearchTextSystemUserMap: (state, action) => {
      state.searchTextSystemUserMap = action.payload;
    },
  },
  extraReducers: (builder) => {
  builder

    // ✅ Admin Sub Broker
    .addCase(getAdminSubBrokerUser.pending, (state) => {
      state.adminSubBrokerUserList = [];
      state.adminSubBrokerUserLoading = true;
    })
    .addCase(getAdminSubBrokerUser.rejected, (state) => {
      state.adminSubBrokerUserList = [];
      state.adminSubBrokerUserLoading = false;
    })
    .addCase(getAdminSubBrokerUser.fulfilled, (state, action) => {
      state.adminSubBrokerUserList = action.payload;
      state.adminSubBrokerUserLoading = false;
    })

    // ✅ Admin System Users
    .addCase(getAdminSystemUsers.pending, (state) => {
      state.adminSystemUserList = [];
      state.adminSystemUserLoading = true;
    })
    .addCase(getAdminSystemUsers.rejected, (state) => {
      state.adminSystemUserList = [];
      state.adminSystemUserLoading = false;
    })
    .addCase(getAdminSystemUsers.fulfilled, (state, action) => {
      state.adminSystemUserList = action.payload?.records;
      state.totalAdminSystemUserList = action?.payload?.totalRecords;
      state.adminSystemUserLoading = false;
    })

    // ✅ Save Admin System Users
    .addCase(saveAdminSystemUsers.pending, (state) => {
      state.adminSystemUserLoading = true;
    })
    .addCase(saveAdminSystemUsers.rejected, (state) => {
      state.adminSystemUserLoading = false;
    })
    .addCase(saveAdminSystemUsers.fulfilled, (state) => {
      state.isUpdatedAdminSystemUser = true;
      state.adminSystemUserLoading = false;
    })

    // ✅ Delete System Users
    .addCase(deleteSystemUsersMap.pending, (state) => {
      state.adminSystemUserLoading = true;
    })
    .addCase(deleteSystemUsersMap.rejected, (state) => {
      state.adminSystemUserLoading = false;
    })
    .addCase(deleteSystemUsersMap.fulfilled, (state) => {
      state.isUpdatedAdminSystemUser = true;
      state.adminSystemUserLoading = false;
    })

    // ✅ Client Map
    .addCase(getAdminClientMapList.pending, (state) => {
      state.adminClientMapList = [];
      state.adminClientMapLoading = true;
    })
    .addCase(getAdminClientMapList.rejected, (state) => {
      state.adminClientMapList = [];
      state.adminClientMapLoading = false;
    })
    .addCase(getAdminClientMapList.fulfilled, (state, action) => {
      state.adminClientMapList = action.payload;
      state.adminClientMapLoading = false;
    })

    // ✅ User Rights
    .addCase(getUserRightsList.pending, (state) => {
      state.userRightsList = [];
      state.isUserRightsList = true;
    })
    .addCase(getUserRightsList.rejected, (state) => {
      state.userRightsList = [];
      state.isUserRightsList = false;
    })
    .addCase(getUserRightsList.fulfilled, (state, action) => {
      if (action.payload.isMaster) {
        state.masterRightsList = action.payload.data;
      } else {
        if (state.masterRightsList) {
          let masterRightsListData = state.masterRightsList;
          let userRightsListData = action.payload.data;

          userRightsListData = userRightsListData.map((item) => {
            const obj = masterRightsListData.find(
              (master) => master.formName === item.formName
            );
            return {
              ...item,
              isViewAllowFormMaster: obj?.isViewAllow,
              isAddAllowFormMaster: obj?.isAddAllow,
              isEditAllowFormMaster: obj?.isEditAllow,
              isDeleteAllowFormMaster: obj?.isDeleteAllow,
            };
          });

          state.userRightsList = userRightsListData;
        } else {
          state.userRightsList = action.payload.data;
        }
      }
      state.isUserRightsList = false;
    })

    // ✅ Authority List
    .addCase(getAuthoritysList.pending, (state) => {
      state.userAuthorityList = [];
      state.userAuthorityListLoading = true;
    })
    .addCase(getAuthoritysList.rejected, (state) => {
      state.userAuthorityList = [];
      state.userAuthorityListLoading = false;
    })
    .addCase(getAuthoritysList.fulfilled, (state, action) => {
      state.userAuthorityList = action.payload;
      state.userAuthorityListLoading = false;
    })

    // ✅ Authority Limits
    .addCase(getAuthoritysLimits.pending, (state) => {
      state.userAuthorityLimits = [];
      state.userAuthorityLimitstLoading = true;
    })
    .addCase(getAuthoritysLimits.rejected, (state) => {
      state.userAuthorityLimits = [];
      state.userAuthorityLimitstLoading = false;
    })
    .addCase(getAuthoritysLimits.fulfilled, (state, action) => {
      state.userAuthorityLimits = action.payload.data.records;
      state.userAuthorityLimitstLoading = false;
    })

    // ✅ Add Authority Limits
    .addCase(addAuthoritysLimits.pending, (state) => {
      state.userAuthorityLimitstLoading = true;
    })
    .addCase(addAuthoritysLimits.rejected, (state) => {
      state.userAuthorityLimitstLoading = false;
    })
    .addCase(addAuthoritysLimits.fulfilled, (state) => {
      state.isUserAuthorityLimitsUpdate = true;
      state.userAuthorityLimitstLoading = false;
    })

    // ✅ Delete Authority Limits
    .addCase(deleteAuthoritysLimits.pending, (state) => {
      state.userAuthorityLimitstLoading = true;
    })
    .addCase(deleteAuthoritysLimits.rejected, (state) => {
      state.userAuthorityLimitstLoading = false;
    })
    .addCase(deleteAuthoritysLimits.fulfilled, (state) => {
      state.isUserAuthorityLimitsUpdate = true;
      state.userAuthorityLimitstLoading = false;
    });
}
});

export const {
  setSortAdminSubBrokerUser,
  setActiveUser,
  setSubBrokerUsersViewData,
  setSearchTextSystemUserMap,
  setSortAdminClientMap,
  setIsUserAuthorityLimitsUpdate,
  setIsUpdatedAdminSystemUser,
  setMultiDeleteSystemUserList,
  setCallPutSettingFromMasterAcc
} = adminSlice.actions;

export default adminSlice.reducer;
